// import React, { useState, useEffect } from 'react';
// import axios from 'axios';
// import { Table, Button } from 'react-bootstrap';
// import Sidebar from '../Sidebar/Sidebar'
// const Order = () => {
//   const [purchases, setPurchases] = useState([]);

//   useEffect(() => {
//     // Fetch purchase data from the API
//     axios.get('https://posapi.emedha.in/api/purchases')
//       .then(response => {
//         setPurchases(response.data);
//       })
//       .catch(error => console.error('Error fetching purchase data:', error));
//   }, []);

//   return (
//     <>
//     <Sidebar/>
//     <div id='main'>
//     <div className="container mt-5">
//       <h1>Purchases</h1>
//       <hr />
//       <Button href="/order-details" variant="success" size="sm" className="mb-3">
//         Add Purchase
//       </Button>
//       <div style={{ overflowX: 'auto' }}>
//         <Table striped bordered hover>
//           <thead>
//             <tr>
//               <th>S.No</th>
//               <th>Bill Number</th>
//               <th>Bill Date</th>
//               <th>Supplier Name</th>
//               <th>Bill Amount</th>
//             </tr>
//           </thead>
//           <tbody>
//             {purchases.map((purchase, index) => (
//               <tr key={purchase.psid}>
//                 <td>{index + 1}</td>
//                 <td><a href={`/order-detail/${purchase.billno}`}>{purchase.billno}</a></td>
//                 <td>{new Date(purchase.billdate).toLocaleDateString()}</td>
//                 <td>{purchase.spname}</td>
//                 <td>Rs. {purchase.billamount.toLocaleString()}</td>
//               </tr>
//             ))}
//           </tbody>
//         </Table>
//       </div>
//     </div>
//     </div>
//     </>
//   );
// };

// export default Order;



// PurchaseTable.js
// import React, { useEffect, useState } from 'react';
// import axios from 'axios';
// import { useTable } from 'react-table';
// import Sidebar from '../Sidebar/Sidebar'
// import { Button } from 'react-bootstrap';

// const Order = () => {
//   const [purchases, setPurchases] = useState([]);

//   useEffect(() => {
//     // Fetch purchases data from the backend
//     axios.get('https://posapi.emedha.in/api/order')
//       .then(response => {
//         setPurchases(response.data);
//       })
//       .catch(error => {
//         console.error('Error fetching purchases:', error);
//       });
//   }, []);

//   // Define the columns for the table
//   const columns = React.useMemo(
//     () => [
//       {
//         Header: 'S.No',
//         accessor: 'psid', // Column accessor
//       },
//       {
//         Header: 'Bill Number',
//         accessor: 'billno',
//       },
//       {
//         Header: 'Bill Date',
//         accessor: 'billdate',
//         Cell: ({ value }) => new Date(value).toLocaleDateString('en-GB'), // Format date
//       },
//       {
//         Header: 'Supplier Name',
//         accessor: 'spname',
//       },
//       {
//         Header: 'Bill Amount',
//         accessor: 'billamount',
//         Cell: ({ value }) => `Rs. ${new Intl.NumberFormat().format(value)}`, // Format number
//       },
//     ],
//     []
//   );

//   // Use react-table hooks
//   const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } = useTable({
//     columns,
//     data: purchases,
//   });

//   return (
//     <>
//     <Sidebar/>
//     <div id='main'>
//     <div>
//       <h1>Purchases</h1>
//       <Button onClick={() => window.location.href = '/order-details'}>Add Purchase</Button>

//       <table {...getTableProps()} className="table table-striped">
//         <thead>
//           {headerGroups.map(headerGroup => (
//             <tr {...headerGroup.getHeaderGroupProps()}>
//               {headerGroup.headers.map(column => (
//                 <th {...column.getHeaderProps()}>{column.render('Header')}</th>
//               ))}
//             </tr>
//           ))}
//         </thead>
//         <tbody {...getTableBodyProps()}>
//           {rows.map(row => {
//             prepareRow(row);
//             return (
//               <tr {...row.getRowProps()}>
//                 {row.cells.map(cell => {
//                   return <td {...cell.getCellProps()}>{cell.render('Cell')}</td>;
//                 })}
//               </tr>
//             );
//           })}
//         </tbody>
//       </table>
//     </div>
//     </div>
//     </>
//   );
// };

// export default Order;


import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useTable } from 'react-table';
import Sidebar from '../Sidebar/Sidebar';

// Self-contained SVG Icons
const Icons = {
  Plus: (size = 16) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
      <line x1="12" y1="5" x2="12" y2="19"></line>
      <line x1="5" y1="12" x2="19" y2="12"></line>
    </svg>
  ),
  Search: (size = 16) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="11" cy="11" r="8"></circle>
      <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
    </svg>
  )
};

const Order = () => {
  const [purchases, setPurchases] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    // Fetch purchases data from the backend
    setLoading(true);
    axios.get('https://posapi.emedha.in/api/order')
      .then(response => {
        setPurchases(response.data || []);
      })
      .catch(error => {
        console.error('Error fetching purchases:', error);
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  // Summary calculations
  const totalSpent = purchases.reduce((sum, p) => sum + (Number(p.billamount) || 0), 0);

  // Define the columns for the table
  const columns = React.useMemo(
    () => [
      {
        Header: 'S.No',
        accessor: 'psid',
        Cell: ({ row }) => (
          <span style={{ color: '#6b7280', fontWeight: '500' }}>
            {row.index + 1}
          </span>
        )
      },
      {
        Header: 'Bill Number',
        accessor: 'billno',
        Cell: ({ value }) => (
          <span style={{ fontFamily: 'monospace', fontWeight: '700', color: '#ea580c', fontSize: '13px' }}>
            {value}
          </span>
        )
      },
      {
        Header: 'Bill Date',
        accessor: 'billdate',
        Cell: ({ value }) => (
          <span style={{ fontSize: '13px', color: '#374151' }}>
            {new Date(value).toLocaleDateString('en-GB')}
          </span>
        )
      },
      {
        Header: 'Supplier Name',
        accessor: 'spname',
        Cell: ({ value }) => (
          <span style={{ fontWeight: '500', color: '#111827' }}>
            {value}
          </span>
        )
      },
      {
        Header: 'Bill Amount',
        accessor: 'billamount',
        Cell: ({ value }) => (
          <span style={{ fontWeight: '700', color: '#111827' }}>
            Rs. {new Intl.NumberFormat().format(value)}
          </span>
        )
      },
    ],
    []
  );

  // Use react-table hooks
  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } = useTable({
    columns,
    data: purchases,
  });

  return (
    <div
     ///style={{ display: 'flex', minHeight: '100vh', backgroundColor: '#fcfaf8' }}
     >
      <Sidebar />

      <div
        id="main"
        style={{
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          minWidth: 0,
          fontFamily: "system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif"
        }}
      >
        <div
          style={{
            padding: isMobile ? '16px' : '28px',
            maxWidth: '1280px',
            width: '100%',
            margin: '0 auto',
            boxSizing: 'border-box',
            display: 'flex',
            flexDirection: 'column',
            gap: '20px'
          }}
        >
          {/* Header Bar */}
          <div
            style={{
              display: 'flex',
              flexDirection: isMobile ? 'column' : 'row',
              alignItems: isMobile ? 'flex-start' : 'center',
              justifyContent: 'space-between',
              gap: '16px',
              width: '100%'
            }}
          >
            <div>
              <h2
                style={{
                  margin: 0,
                  fontSize: isMobile ? '22px' : '26px',
                  fontWeight: '700',
                  color: '#111827',
                  fontFamily: "'Cinzel', serif"
                }}
              >
                Purchases
              </h2>
              <p style={{ margin: '4px 0 0 0', fontSize: '14px', color: '#6b7280' }}>
                {purchases.length} total purchases recorded
              </p>
            </div>

            <button
              onClick={() => window.location.href = '/order-details'}
              style={{
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '8px',
                padding: '10px 20px',
                borderRadius: '12px',
                fontSize: '14px',
                fontWeight: '600',
                color: '#ffffff',
                background: 'linear-gradient(135deg, #f97316, #c2410c)',
                boxShadow: '0 4px 16px rgba(249, 115, 22, 0.3)',
                border: 'none',
                cursor: 'pointer',
                width: isMobile ? '100%' : 'auto'
              }}
            >
              {Icons.Plus(16)}
              <span>Add Purchase</span>
            </button>
          </div>

          {/* Summary Card */}
          <div
            style={{
              display: 'grid',
              gridTemplateColumns: isMobile ? '1fr' : 'repeat(2, 1fr)',
              gap: '16px',
              width: '100%'
            }}
          >
            <div
              style={{
                backgroundColor: '#ffffff',
                borderRadius: '16px',
                border: '1px solid #ffedd5',
                padding: '20px',
                boxShadow: '0 1px 3px rgba(0,0,0,0.05)'
              }}
            >
              <p style={{ margin: '0 0 4px 0', fontSize: '12px', color: '#9ca3af', fontWeight: '500' }}>Total Spent</p>
              <p style={{ margin: 0, fontSize: '24px', fontWeight: '700', color: '#ea580c' }}>₹{totalSpent.toLocaleString()}</p>
            </div>
            <div
              style={{
                backgroundColor: '#ffffff',
                borderRadius: '16px',
                border: '1px solid #ffedd5',
                padding: '20px',
                boxShadow: '0 1px 3px rgba(0,0,0,0.05)'
              }}
            >
              <p style={{ margin: '0 0 4px 0', fontSize: '12px', color: '#9ca3af', fontWeight: '500' }}>Orders Count</p>
              <p style={{ margin: 0, fontSize: '24px', fontWeight: '700', color: '#16a34a' }}>{purchases.length} orders</p>
            </div>
          </div>

          {/* Table View */}
          {loading ? (
            <div style={{ textAlign: 'center', padding: '50px 0', color: '#6b7280', fontSize: '14px' }}>
              Loading purchases...
            </div>
          ) : (
            <div
              style={{
                backgroundColor: '#ffffff',
                borderRadius: '16px',
                border: '1px solid #ffedd5',
                boxShadow: '0 1px 3px rgba(0,0,0,0.05)',
                width: '100%',
                overflow: 'hidden'
              }}
            >
              <div style={{ width: '100%', overflowX: 'auto' }}>
                <table
                  {...getTableProps()}
                  style={{
                    width: '100%',
                    minWidth: '650px',
                    borderCollapse: 'collapse',
                    textAlign: 'left'
                  }}
                >
                  <thead>
                    {headerGroups.map((headerGroup, hgIdx) => (
                      <tr
                        key={hgIdx}
                        {...headerGroup.getHeaderGroupProps()}
                        style={{
                          backgroundColor: 'rgba(255, 247, 237, 0.6)',
                          borderBottom: '1px solid #ffedd5',
                          fontSize: '12px',
                          fontWeight: '600',
                          color: '#374151',
                          textTransform: 'uppercase',
                          letterSpacing: '0.05em'
                        }}
                      >
                        {headerGroup.headers.map((column, cIdx) => (
                          <th
                            key={cIdx}
                            {...column.getHeaderProps()}
                            style={{ padding: '14px 20px' }}
                          >
                            {column.render('Header')}
                          </th>
                        ))}
                      </tr>
                    ))}
                  </thead>
                  <tbody {...getTableBodyProps()} style={{ fontSize: '14px' }}>
                    {rows.length > 0 ? (
                      rows.map((row, rIdx) => {
                        prepareRow(row);
                        return (
                          <tr
                            key={rIdx}
                            {...row.getRowProps()}
                            style={{
                              borderBottom: '1px solid #fff7ed',
                              backgroundColor: '#ffffff'
                            }}
                          >
                            {row.cells.map((cell, cellIdx) => (
                              <td
                                key={cellIdx}
                                {...cell.getCellProps()}
                                style={{ padding: '16px 20px' }}
                              >
                                {cell.render('Cell')}
                              </td>
                            ))}
                          </tr>
                        );
                      })
                    ) : (
                      <tr>
                        <td
                          colSpan={columns.length}
                          style={{
                            textAlign: 'center',
                            padding: '36px 0',
                            color: '#9ca3af',
                            fontSize: '14px'
                          }}
                        >
                          No purchase records found.
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Order;